// src/components/ui/EmptyState.jsx
// One standard "no data" placeholder, replacing the ad hoc
// `<div className="text-center py-5 text-muted">...</div>` copies
// scattered across ~14 files with inconsistent wording/markup.
import React from "react";
import { FiInbox } from "react-icons/fi";

const EmptyState = ({ message = "Không có dữ liệu", action = null }) => (
  <div className="text-center text-muted py-5 zto-empty-state">
    <FiInbox size={32} className="mb-2 opacity-50" aria-hidden="true" />
    <div>{message}</div>
    {action && <div className="mt-3">{action}</div>}
  </div>
);

export default EmptyState;
